module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0011-aa29af0a797247d977ec5d535a1bc600.jpg";